const CHUNK_ERROR_PATTERN = /ChunkLoadError|Loading (?:CSS )?chunk [^ ]+ failed|Failed to fetch dynamically imported module/i
const RECOVERY_PARAMETER = '__shareai_chunk_retry'

const isChunkLoadError = error => {
  const message = [error?.name, error?.message, error?.stack]
    .filter(Boolean)
    .join(' ')

  return CHUNK_ERROR_PATTERN.test(message)
}

const removeRecoveryParameter = () => {
  const url = new URL(window.location.href)
  if (!url.searchParams.has(RECOVERY_PARAMETER)) return

  url.searchParams.delete(RECOVERY_PARAMETER)
  window.history.replaceState(window.history.state, '', url.href)
}

export const installChunkRecovery = router => {
  router.onError(error => {
    if (!isChunkLoadError(error)) return

    const url = new URL(window.location.href)

    // A unique query forces intermediaries to return the newest index.html.
    // Keep the existing hash route so the user returns to the same page.
    if (url.searchParams.has(RECOVERY_PARAMETER)) return

    url.searchParams.set(RECOVERY_PARAMETER, Date.now().toString(36))
    window.location.replace(url.href)
  })

  router.isReady().then(removeRecoveryParameter).catch(() => {
    // router.onError handles recoverable chunk failures.
  })
}
